export default "__VITE_ASSET__Nal8jK9K__"